export default __webpack_public_path__ + "static/media/warehouse.de95844b.svg";